import chrisPic from "@/public/images/artists/chris.png";
import { Artist } from "@/types/types";

export const chris = {
  id: "142",
  name: "Chris",
  image: chrisPic,
  description: `Chris's delivery is smooth, allowing him to effortlessly transition between rapping and singing. Well suited for chill and laid-back rap verses with melodic elements.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fchris-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop", "Pop", "Dance"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 50,
        high: 70,
      },
      sweetSpot: 59,
    },
  },
} as const satisfies Artist;
